export {Icon, StyledRmwcIcon} from './icon'
